// components/forms/change_password_form.js
import { useDispatch, useSelector } from "react-redux";
import { selectTSUserId, setForcePasswordChange } from "../../redux/globalsSlice";
import { confirmationDialog, EVENT_TOPIC_FOR_TRANSACTION_SERVER, JSON_KEY_CONFIRMATION_PASSWORD, JSON_KEY_MESSAGE_TYPE, JSON_KEY_NEW_PASSWORD, JSON_KEY_PASSWORD, JSON_KEY_SUBMITTER, JSON_KEY_USER, ShowError } from "../../common/common";
import { MSGTYPE_CHANGE_PASSWORD, MSGTYPE_USER_PASSWORD } from "../../common/msg_types";
import { useEffect, useRef, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { forceLogoffWithoutConfirm } from "./logoff_immedately";

export const ChangePasswordForm = ({ setLoggedOn, onClose, forced = false }) => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const tsUserIdRef = useRef(tsUserId);

   const [currentPassword, setCurrentPassword] = useState('');
   const [newPassword, setNewPassword] = useState('');
   const [confirmationPassword, setConfirmationPassword] = useState('');
    
   // Form handling
   const {
      handleSubmit,
   } = useForm({});
   
   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);
   
   const onSubmit = (data) => {
      const change_password = {
         [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_CHANGE_PASSWORD,
         [JSON_KEY_USER]: tsUserIdRef.current,
         [JSON_KEY_SUBMITTER]: tsUserIdRef.current,
         [JSON_KEY_PASSWORD]: currentPassword,
         [JSON_KEY_NEW_PASSWORD]: newPassword,
         [JSON_KEY_CONFIRMATION_PASSWORD]: confirmationPassword,
      };

      DispatchTransactionEvent(
         EVENT_TOPIC_FOR_TRANSACTION_SERVER,
         MSGTYPE_USER_PASSWORD,
         change_password
      );

      dispatch(setForcePasswordChange(false));
   };

   const ValidateFields = () => {
      if (!currentPassword) return "Current password is missing";
      if (!newPassword) return "New password is missing";
      if (!confirmationPassword) return "Confirmation password is missing";
      if (newPassword !== confirmationPassword) return "New passwords do not match";
      if (currentPassword === newPassword) return "New password must be different to current password";
      return null;
   };

   const onChangePasswordSubmit = async () => {
      const error = ValidateFields();

      if (error) {
         onClose?.(); // 👈 hide the form first
         setTimeout(() => {
            ShowError(error); // 👈 then show the error after the form is gone
         }, 0);
         return;
      }

      onClose?.(); // hide the form before the confirmation

      const confirmed = await confirmationDialog({
         title: "Change Password",
         text: `Changing password for user: ${tsUserIdRef.current}`,
      });

      if (confirmed) {
         onSubmit();
      } else {
         setTimeout(() => {
            onClose?.(false); // re-show form if user cancels
         }, 0);
      }
   };



   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
         document.activeElement.blur();
      }

      if (forced) {
         dispatch(setForcePasswordChange(false));
         setLoggedOn(false); 
         forceLogoffWithoutConfirm(); // 💥 kick them out
      } else {
         onClose?.(); // just close the panel
      }
   };

   return (
      <form className="window-center" onSubmit={handleSubmit(onChangePasswordSubmit)} style={{ maxWidth: "400px", margin: "auto" }}>
         <h3 className="form-title text-center">Change Password for: {tsUserIdRef.current}</h3>

         <div className="mb-3">
            <label className="form-label">Current Password</label>
            <input
               className="form-control"
               type="password"
               value={currentPassword}
               onInput={(e) => setCurrentPassword(e.target.value)}
            />
         </div>

         <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
               className="form-control"
               type="password"
               value={newPassword}
               onInput={(e) => setNewPassword(e.target.value)}
            />
         </div>

         <div className="mb-3">
            <label className="form-label">Repeat Password</label>
            <input
               className="form-control"
               type="password"
               value={confirmationPassword}
               onInput={(e) => setConfirmationPassword(e.target.value)}
            />
         </div>

         <div className="d-flex justify-content-between mt-4">
            <Button variant="secondary" size="lg" onClick={handleCancel}>
               Cancel
            </Button>
            <Button variant="success" size="lg" type="submit">
               Submit
            </Button>
         </div>
      </form>
   );
};
